import { Tag } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class Scope extends Tag {
    static of(scope) {
        return new Scope(scope);
    }
    _scope;
    constructor(scope) {
        super();
        this._scope = scope;
    }
    get type() {
        return "scope";
    }
    get scope() {
        return this._scope;
    }
    equals(value) {
        return value instanceof Scope && value._scope === this._scope;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            scope: this._scope,
        };
    }
}
/**
 * @public
 */
(function (Scope) {
    /**
     * For rules that test failures at the page level. These rules only make sense
     * to include in an audit if an entire page is available.
     */
    Scope.Page = Scope.of("page");
    /**
     * For rules that test failures at the component level. These rules only make
     * sense to include in an audit if at least an entire component is available.
     */
    Scope.Component = Scope.of("component");
})(Scope || (Scope = {}));
//# sourceMappingURL=scope.js.map